<template>

  <div class="modal fade register" id="register_popup" tabindex="-1" role="dialog"
       aria-labelledby="" aria-hidden="true" data-backdrop="static"
       data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">

      <div class="modal-content step1_register" :class="step === 1 ? '': 'd-none'">
        <button type="button" class="close" @click="closeModal()" data-dismiss="modal" aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Maak hier je MySurprise account aan</h5>
        </div>
        <div class="modal-body">
          <form>
            <!-- Mobile Number Input -->
            <div :class="{'form-group': true, 'error': !isValidMsisdn}">
              <input type="tel" class="form-control" id="mobile_step1" name="mobile_step1"
                     placeholder="Je mobiele nummer" v-model="msisdn" required/>
              <label v-if="!isValidMsisdn" class="form-control-label" for="mobile_step1"></label>
              <div v-if="!isValidMsisdn" class="error_msg">
                Ongeldig mobiele nummer. Je mobiele nummer moet beginnen met 06 en bestaat uit 10 cijfers.
                Of beginnend met 097 en bestaand uit 12 cijfers.
              </div>
            </div>

            <!-- Select All Option -->
            <p class="mt-4">
              <input type="radio" id="option3" name="radio-group1"
                     @click="toggleSelectAll" :checked="selectAllActive">
              <label for="option3">Alles selecteren</label>
            </p>

            <!-- Age Selection Options -->
            <p class="mt-2">
              <input type="radio" id="option1" value="option1" v-model="ageOption" name="radio-group">
              <label for="option1">Ik ben 18 jaar of ouder</label>
            </p>
            <p class="mt-2">
              <input type="radio" id="option2" value="option2" v-model="ageOption" name="radio-group">
              <label for="option2">Ik ben jonger dan 18 jaar <br>en heb toestemming van mijn ouders</label>
            </p>
            <div v-if="!confirmedAgeOption" class="error_msg error_age_t_c"> Bevestig je leeftijd</div>

            <!-- Terms Checkbox -->
            <div class="check">
              <input type="checkbox" id="terms" v-model="acceptTerms">
              <label for="terms">Ik ga akkoord met de <a href="static/docs/Actievoorwaarden.pdf" target="_blank">Actievoorwaarden</a></label>
            </div>
            <div v-if="!validTerms" class="error_msg error_age_t_c"> Accepteer de Actievoorwaarden om door te gaan</div>

            <!-- Marketing Consent Checkbox -->
            <div class="check">
              <input type="checkbox" id="privacy" class="termsCheckbox" v-model="marketingConsent">
              <label for="privacy">
                Odido mag mij op basis van mijn verbruiks- en persoonsgegevens persoonlijk (via sms/email/bellen)
                advies geven, passende aanbiedingen sturen en relevante content tonen. Zo kunnen we je tips geven
                over je dataverbruik of over het aanpassen van je bundels. Bekijk voor meer informatie ons
                <a href="https://www.odido.nl/privacy" target="_blank">Privacy statement.</a>
              </label>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div v-if="internalError" class="error_msg">Oeps, er ging iets fout. Probeer het later nog eens. </div>
          <div v-if="registeredAsOptOut" class="error_msg">Je bent momenteel afgemeld voor Prepaid Surprise.
            Als je doorgaat word je automatisch weer angemeld en ontvang je vanaf nu weer berichten en speelcodes van Prepaid Surprise.
          </div>
          <button
            class="black_btn step1"
            @click.prevent="proceedToStep2"
            type="button">Bevestigen
          </button>
          <div class="dots-container">
            <div class="dot step1 active"></div>
            <div class="dot step2"></div>
            <div class="dot step3"></div>
          </div>
        </div>
      </div>

      <!-- Step 2: PIN Verification -->
      <div class="modal-content step2_register" :class="step === 2 ? '': 'd-none'">
        <button type="button" @click="closeModal()" class="close" data-dismiss="modal" aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Verificatie van je mobiele nummer</h5>
          <h4>
            We hebben je een pincode gestuurd naar het volgende mobiele nummer: {{this.msisdn}}<br> Vul de ontvangen
            pincode in
          </h4>
        </div>
        <div class="modal-body">
          <form class="verification">
            <div class="d-flex justify-content-center">
              <input type="text" id="input1" ref="input1" maxlength="1" class="form-control" v-model="pin1"
                     @keyup.exact="gotoInput(2)" @keyup.exact.backspace="backToInput(1)" @focus="selectInput(1)">
              <input type="text" ref="input2" maxlength="1" class="form-control" v-model="pin2"
                     @keyup.exact="gotoInput(3)" @keyup.exact.backspace="backToInput(1)" @focus="selectInput(2)">
              <input type="text" ref="input3" maxlength="1" class="form-control" v-model="pin3"
                     @keyup.exact="gotoInput(4)" @keyup.exact.backspace="backToInput(2)" @focus="selectInput(3)">
              <input type="text" ref="input4" maxlength="1" class="form-control" v-model="pin4"
                     @keyup.exact="gotoInput(5)" @keyup.exact.backspace="backToInput(3)" @focus="selectInput(4)">
              <input type="text" ref="input5" maxlength="1" class="form-control" v-model="pin5"
                     @keyup.exact.backspace="backToInput(4)" @focus="selectInput(5)">
            </div>
            <div v-if="!isValidPin" class="error_msg">Pincode onjuist</div>

          </form>
        </div>
        <div class="modal-footer">
          <div v-if="internalError" class="error_msg">Oeps, er ging iets fout. Probeer het later nog eens.
          </div>
          <button type="button" @click.prevent="proceedToStep3" class="black_btn step2">Bevestigen</button>
          <div class="dots-container">
            <div class="dot step1"></div>
            <div class="dot step2 active"></div>
            <div class="dot step3"></div>
          </div>
        </div>
      </div>

      <!-- Step 3: Password Setup -->
      <div class="modal-content step3_register" :class="step === 3 ? '': 'd-none'">
        <button type="button" @click="closeModal()" class="close" data-dismiss="modal" aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Wachtwoord instellen</h5>
        </div>
        <div class="modal-body">
          <form>
            <div :class="{'form-group': true, 'error': !isValidPassword}">
              <input type="password" class="form-control" id="password"
                     name="password" placeholder="Wachtwoord" required
                     v-model="password"/>
              <label v-if="!isValidPassword" class="form-control-label" for="password">Wachtwoord</label>
              <div v-if="!isValidPassword" class="error_msg">Wachtwoord bevat minder dan 8 tekens.</div>
            </div>
            <div :class="{'form-group': true, 'error': !isValidConfirmPassword}">
              <input type="password" class="form-control" id="pass"
                     name="pass" placeholder="Herhaal wachtwoord" required
                     v-model="confirmPassword"/>
              <label v-if="!isValidConfirmPassword" class="form-control-label" for="pass">Herhaal wachtwoord</label>
              <div v-if="!isValidConfirmPassword" class="error_msg">Wachtwoorden komen niet overeen</div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" @click.prevent="createNewPassword" class="black_btn step3">Bevestigen</button>
          <div class="dots-container">
            <div class="dot step1"></div>
            <div class="dot step2"></div>
            <div class="dot step3 active"></div>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import router from "../../router";
import gtm_analytics from "../../common/mixin/gtm_analytics";

export default {
  name: 'Register',
  mixins: [
    gtm_analytics
  ],
  data() {
    return {
      msisdn: null,
      isValidMsisdn: true,
      ageOption: null,
      confirmedAgeOption: 'none',
      acceptTerms: false,
      validTerms: true,
      step: 1,
      pin1: "",
      pin2: "",
      pin3: "",
      pin4: "",
      pin5: "",
      isValidPin: true,
      password: null,
      confirmPassword: null,
      isValidPassword: true,
      isValidConfirmPassword: true,
      registeredAsOptOut: false,
      attemptToRegisterAsOptOut: false,
      selectAllActive: false,
      marketingConsent: false,
      internalError: false
    }
  },

  mounted() {
    $('#register_popup').modal('show')
    this.pushPopUp('Popup visit', 'Register Pop Up')
  },

  computed: {
    ...mapGetters([
      'getLoginResponse',
      'isRegisterModalOpen',
      'getPinResponse',
      'getAuthenticatePinResponse',
      'getHasPasswordResponse',
      'getCreatePasswordResponse'
    ]),

    pins() {
      return this.pin1 + this.pin2 + this.pin3 + this.pin4 + this.pin5;
    }
  },

  methods: {
    ...mapMutations([
      'updateRegisterModal',
      'updateMsisdn',
      'updatePinResponse',
      'updateAuthenticatePinResponse',
      'updateLoginModal',
      'updatePassword',
      'updateAccessToken',
      'updateRegisterAsOptIn'
    ]),

    ...mapActions([
      'accountLogin',
      'generatePin',
      'authenticatePin',
      'hasPassword',
      'createPassword',
      'optInCustomer',
      'updateMarketingConsent'
    ]),

    // Toggle "Alles selecteren" functionality - Selects: Age 18+, Terms, Marketing (but NOT under-18 option)
    toggleSelectAll() {
      if (this.selectAllActive) {
        // Currently active → deselect everything
        this.ageOption = null // Age selection off
        this.acceptTerms = false // Terms off
        this.marketingConsent = false // Marketing off
        this.selectAllActive = false // Select all off
      } else {
        // Currently inactive → select specific options
        this.ageOption = 'option1' // Age 18+ ON
        this.acceptTerms = true // Terms ON
        this.marketingConsent = true // Marketing ON (always available in registration)
        this.selectAllActive = true // Select all ON
      }
    },

    // Save marketing consent when form is submitted
    saveMarketingConsent() {
      if (this.marketingConsent) {
        this.updateMarketingConsent({
          msisdn: this.msisdn
        })
          .catch((error) => {
            console.error('Error updating marketing consent:', error)
          })
      }
    },

    closeModal() {
      $('#register_popup').modal('hide')
      this.updateRegisterModal(false)
    },

    msisdnValidation() {
      return (/^(06[0-9]{8}|097[0-9]{9})$/.test(this.msisdn))
    },

    passwordValidation() {
      return (/^.{8,}$/.test(this.password))
    },

    resetValidityFlags() {
      this.isValidPassword = true
      this.isValidConfirmPassword = true
      this.isValidPin = true
      this.registeredAsOptOut = false
      this.internalError = false
    },

    gotoInput(num) {
      const input = this.$refs["input" + num];
      input.select();
      input.focus();
    },

    selectInput(num) {
      this.$refs["input" + num].select();
    },

    backToInput(num) {
      this["pin" + num + 1] = "";
      this.gotoInput(num);
    },

    proceedToStep2() {
      this.resetValidityFlags()
      // store user's inputs
      this.isValidMsisdn = this.msisdnValidation()
      this.confirmedAgeOption = this.ageOption
      this.validTerms = this.acceptTerms

      if (this.validTerms && this.isValidMsisdn && this.confirmedAgeOption) {
        this.updateMsisdn(this.msisdn)
        this.updatePinResponse(null)
        const payload = { msisdn: this.msisdn }

        // check if user has already password
        this.hasPassword(payload)
          .then(() => {
            if (this.getHasPasswordResponse !== null) {
              this.handlePasswordResponse()
            } else {
              this.internalError = true
            }
          })
      }
    },

    handlePasswordResponse() {
      if (this.getHasPasswordResponse.hasPassword !== null) {
        if (!this.getHasPasswordResponse.hasPassword) {
          // User's msisdn exists but does not have password. proceed with register
          this.generatePinCode()
        } else {
          // User's msisdn exists and has password. Redirect to Login page
          if (this.marketingConsent) {
            this.$store.commit('storeRegisterMarketingConsentTemp', {
              msisdn: this.msisdn,
              consent: true
            })
          }

          this.updateRegisterAsOptIn(true)
          this.goToLogin()
        }
      } else {
        // User's msisdn does NOT exist
        if (this.getHasPasswordResponse.failReason === "NOT_EXISTS")
          this.isValidMsisdn = false
        // User is opted out
        else if (this.getHasPasswordResponse.failReason === "OPTED_OUT") {
          // when customer press again the 'bevestigen' button attemptToRegisterAsOptOut = true
          if (this.attemptToRegisterAsOptOut) {
            this.optIn()
          } else {
            this.attemptToRegisterAsOptOut = true
            this.registeredAsOptOut = true
          }
        }
        else
          this.internalError = true
      }
    },

    optIn() {
      this.optInCustomer({ msisdn: this.msisdn })
        .then(() => {
          if (this.getOptInResponse === null) {
            this.internalError = true
          } else {
            this.proceedToStep2()
          }
        })
    },

    generatePinCode() {
      this.generatePin({ msisdn: this.msisdn, forgotPassword: false })
        .then(() => {
          if (this.getPinResponse !== null && this.getPinResponse.result === "SUCCESS") {
            this.step = 2;
          } else {
            this.internalError = true
          }
        })
    },

    goToLogin() {
      $('#register_popup').modal('hide')
      this.updateRegisterModal(false)
      this.updateLoginModal(true)
    },

    proceedToStep3() {
      this.resetValidityFlags()
      if (this.pins.length === 5) {
        const payload = {
          msisdn: this.msisdn,
          inputPin: this.pins,
        };
        this.authenticatePin(payload)
          .then(() => {
            if (this.getAuthenticatePinResponse.result === "SUCCESS") {
              this.step = 3;
            } else if (this.getAuthenticatePinResponse.failReason === "WRONG_PIN") {
              this.isValidPin = false
            } else {
              this.internalError = true
            }
          })
      } else {
        this.isValidPin = false
      }
    },

    createNewPassword() {
      // validate Password
      this.resetValidityFlags()
      if (!this.passwordValidation()) {
        this.isValidPassword = false
      } else {
        this.isValidPassword = true
        // compare password and confirmPassword
        if (!this.comparePasswords()) {
          this.isValidConfirmPassword = false
        } else {
          this.isValidConfirmPassword = true
          const payload = { msisdn: this.msisdn, password: this.password }
          this.createPassword(payload)
            .then(() => {
              this.handleCreatePasswordResponse()
            })
        }
      }
    },

    comparePasswords() {
      return this.password === this.confirmPassword
    },

    handleCreatePasswordResponse() {
      if (this.getCreatePasswordResponse.result === "SUCCESS") {
        this.submitLogin()
      } else {
        this.internalError = true
      }
    },

    submitLogin() {
      this.updateMsisdn(this.msisdn)
      this.updatePassword(this.password)
      this.accountLogin()
        .then(() => {
          if (this.getLoginResponse.isUserLoggedIn === true) {
            this.saveMarketingConsent()
            this.updateAccessToken(this.getLoginResponse.encryptedKey)
            this.updateRegisterModal(false)
            $('#register_popup').modal('hide')
            router.push({ name: 'Account' })
          } else {
            if (this.getLoginResponse.failReason === 'WRONG_PASSWORD') {
              this.isValidPassword = false
            } else if (this.getLoginResponse.failReason === 'NOT_REGISTERED') {
              this.isValidMsisdn = false
            } else {
              this.internalError = true
            }
          }
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/Register.vue